// extracted by mini-css-extract-plugin
export var checkbox = "_2b-0";
export var circle = "_2b-3";
export var horizontalContainer = "_2b-7";
export var sm = "_2b-5";
export var switch0 = "_2b-2";
export var switchDisabled = "_2b-8";
export var switchEnabled = "_2b-1";
export var textSwitchContainer = "_2b-9";
export var textSwitchOption = "_2b-a";
export var textSwitchOptionSelected = "_2b-b";
export var verticalContainer = "_2b-6";
export var xs = "_2b-4";